import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Button, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { ModalEduAdd } from 'components';

import styles from './Edu.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class EduHeader extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isModal,
      formStore,
      eduExamOrdering,
      eduExamByExamNo,
      eduAttachOrdering,
      eduAttachByAttachNo,
      eduTagOrdering,
      eduTagByTagNo,
      selectEduNo,
      eduName,
      totalEdu,
      totalTarget,
      // function
      handleChangeExam,
      onToggleModal,
      onEduToggleModal,
      onPostEdu,
      onEduRefresh,
      initEduLicense,
      // 로딩 & 클릭
      isClicked,
      isLoading,
      // 에러 & 에러 결과
      licenseResult,
      isError,
      onGetVideoQuiz,
      eduVideoQuizInfo
    } = this.props;

    return (
      <div className={cx('eduHeader-wrapper')}>
        {/* {isModal === 'eduAdd' && (
          <ModalEduAdd
            visible
            onPostEdu={onPostEdu}
            onToggleModal={onToggleModal}
            initEduLicense={initEduLicense}
            eduExamByExamNo={eduExamByExamNo}
            eduExamOrdering={eduExamOrdering}
            eduAttachOrdering={eduAttachOrdering}
            eduAttachByAttachNo={eduAttachByAttachNo}
            eduTagOrdering={eduTagOrdering}
            eduTagByTagNo={eduTagByTagNo}
            tagData={eduTagByTagNo.toJS()}
            isLoading={isLoading}
            isClicked={isClicked}
            licenseResult={licenseResult}
            isError={isError}
            formStore={formStore}
            handleChangeExam={handleChangeExam}
            onGetVideoQuiz={onGetVideoQuiz}
            eduVideoQuizInfo={eduVideoQuizInfo}
          />
        )} */}

        <div className={cx('title-area')}>
          <div className={cx('exam-title')}>
            <Tooltip
              title={
                selectEduNo === 'all'
                  ? defineMessages(formatMessage({ id: 'EduHeader_1', defaultMessage: '전체 교육' }))
                  : eduName
              }
              placement="bottom-start">
              <div className={cx('exam-name')}>
                <div className={cx('ellipsis')}>
                  {selectEduNo === 'all'
                    ? defineMessages(formatMessage({ id: 'EduHeader_1', defaultMessage: '전체 교육' }))
                    : eduName}
                </div>
              </div>
            </Tooltip>
          </div>
          <div className={cx('exam-date')}>
            {selectEduNo === 'all'
              ? defineMessages(formatMessage({ id: 'Edu_36', defaultMessage: '총 교육' })) +
                ': ' +
                totalEdu +
                defineMessages(formatMessage({ id: 'Edu_37', defaultMessage: '개' })) +
                ', ' +
                defineMessages(formatMessage({ id: 'Edu_38', defaultMessage: '대상자' })) +
                ': ' +
                totalTarget +
                defineMessages(formatMessage({ id: 'Edu_39', defaultMessage: '명' }))
              : defineMessages(formatMessage({ id: 'Edu_45', defaultMessage: '총 대상자' })) +
                ': ' +
                totalTarget +
                defineMessages(formatMessage({ id: 'Edu_39', defaultMessage: '명' }))}
          </div>
        </div>

        <div className={cx('header-right-area')}>
          <div className={cx('button-area')}>
            {/* 새로고침 버튼 */}
            <Tooltip
              title={defineMessages(formatMessage({ id: 'ExamHeader_9', defaultMessage: '새로 고침' }))}
              classes={{ tooltip: 'tooltip-noMaxWidth' }}
              placement="bottom">
              <div className={cx('refresh')} onClick={onEduRefresh}>
                <Image src="/img/exam/menu_refresh.png" />
              </div>
            </Tooltip>

            {/* <Button className={cx('bt-startEdu')} onClick={() => onEduToggleModal('eduAdd')}>
              {defineMessages(formatMessage({ id: 'EduAdd_1', defaultMessage: '교육 실시' }))}
            </Button> */}
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(EduHeader);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduHeader.js